<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="userId" v-if="adminShow">
        <el-select v-model="queryParams.userId" filterable placeholder="代理商" @change="search" clearable>
            <el-option v-for="item in agentList" :key="item.userId" :label="handleAgent(item)" :value="item.userId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="poolName">
        <el-input v-model="queryParams.poolName" placeholder="流量池名称"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="poolType" v-if="adminShow">
        <el-select v-model="queryParams.poolType" filterable placeholder="流量池类型" @change="search" clearable>
          <el-option v-for="item in operator" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="status">
        <el-select v-model="queryParams.status" filterable placeholder="状态" @change="search" clearable>
          <el-option label="启用中" value="1" />
          <el-option label="未启用" value="0" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="dateRange"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="创建开始"
          end-placeholder="创建结束"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="add" v-hasPermi="['pondManage:add']">新增</el-button>
        <el-dropdown @command="(command) => handleCommand(command)" style="margin-left: 10px" v-hasPermi="['pondManage:allocation','pondManage:recycle']">
          <el-button type="primary">SIM配置<i class="el-icon-arrow-down el-icon--right"></i></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="handleCardAllocation" icon="el-icon-star-on" v-hasPermi="['pondManage:allocation']">卡分配</el-dropdown-item>
            <el-dropdown-item command="handleCardRecycle" icon="el-icon-delete" v-hasPermi="['pondManage:recycle']">卡回收</el-dropdown-item>
            <el-dropdown-item command="handlePoolRenewal" icon="el-icon-money" v-hasPermi="['pondManage:renewal']">池续约</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border @sort-change="tableSortChange">
      <el-table-column fixed type="expand">
        <template slot-scope="props">
          <el-form label-position="left"  class="pond-table-expand" :inline="true" style="width:600px">
            <el-form-item label="单卡停机保号费">
              <span>{{ props.row.cardProductFee }}元</span>
            </el-form-item>
            <el-form-item label="单卡功能管理费">
              <span>{{ props.row.cardFunctionFee }}元</span>
            </el-form-item>
            <template v-if="props.row.poolType == '单卡模式'">
              <el-form-item label="单卡低消流量">
                <span>{{ props.row.singleLowFlow }}</span>
              </el-form-item>
              <el-form-item label="单卡低消费用">
                <span>{{ props.row.singleLowFlowFee }}元</span>
              </el-form-item>
              <el-form-item label="超流单价">
                <span>{{ props.row.singleOverFlowFee }}元/GB</span>
              </el-form-item>
            </template>
            <template v-if="props.row.poolType == '总量模式'">
              <el-form-item label="初始池总量">
                <span>{{ props.row.poolTotalFlow }}</span>
              </el-form-item>
              <el-form-item label="流量池单价">
                <span>{{ props.row.poolTotalFlowFee }}元</span>
              </el-form-item>
            </template>
            <template v-if="props.row.poolType == '套餐模式'">
              <el-form-item label="单卡月流量">
                <span>{{ props.row.singleFlow }}</span>
              </el-form-item>
              <el-form-item label="单卡月费用">
                <span>{{ props.row.singlePrice }}元</span>
              </el-form-item>
            </template>
            <template v-if="props.row.poolType == '后付款模式'">
              <el-form-item label="流量单价">
                <span>{{ props.row.singlePrice }}</span>
              </el-form-item>
            </template>
            
          </el-form>
        </template>
      </el-table-column>
      <el-table-column v-if="adminShow" fixed type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column fixed prop="companyName" label="代理商" align="center" width="300px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column fixed prop="poolName" label="流量池名称" align="center" width="200px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column fixed prop="poolType" label="类型" align="center"  width="120px">
        <template slot-scope="{row}">
          <el-tag>{{row.poolType}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="operationType" label="运营商" align="center" width="85px"></el-table-column>
      <el-table-column prop="poolUseFlow" label="已用流量" align="center" width="100px"></el-table-column>
      <el-table-column prop="poolTotalFlow" label="池总流量" align="center" width="100px" :formatter="poolTotalFlowFormat"></el-table-column>
      <el-table-column prop="singleFlowLimit" label="单卡月峰值" align="center" min-width="100px"></el-table-column>
      <el-table-column prop="cardNumber" label="卡总数" align="center" width="85px"></el-table-column>
      <el-table-column prop="expireTime" label="到期时间" align="center" width="150px" sortable="custom" :formatter="expireTimeFormat" >
        
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center" width="150px" sortable="custom"></el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="85px">
        <template slot-scope="{row}">
          <el-tag v-if="row.status =='1'">启用中</el-tag>
          <el-tag  v-else type="danger">未启用</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center" width="150px" v-if="adminShow"></el-table-column>
      <el-table-column label="操作" width="300" align="center" fixed="right" v-if="adminShow">
        <template slot-scope="scope">
          <el-button size="mini"  type="text" plain icon="el-icon-view" @click="details(scope.row)" v-hasPermi="['pondManage:view']">详情</el-button>
          <el-button size="mini"  type="text" plain icon="el-icon-edit" @click="editRow(scope.row)" v-hasPermi="['pondManage:edit']">编辑</el-button>
          <el-button size="mini"  type="text" plain icon="el-icon-copy" @click="copyRow(scope.row)" v-hasPermi="['pondManage:add']">复制</el-button>
          <el-dropdown v-if="scope.row.status == '1'" @command="(command) => handleCommand(command,scope.row)" style="margin-left: 10px" v-hasPermi="['pondManage:allocation','pondManage:recycle','pondManage:renewal']">
            <el-button size="mini" type="text" plain >SIM配置<i class="el-icon-arrow-down el-icon--right"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="handleCardAllocation" icon="el-icon-star-on" v-hasPermi="['pondManage:allocation']">卡分配</el-dropdown-item>
              <el-dropdown-item command="handleCardRecycle" icon="el-icon-delete" v-hasPermi="['pondManage:recycle']">卡回收</el-dropdown-item>
              <el-dropdown-item command="handlePoolRenewal" icon="el-icon-money" v-hasPermi="['pondManage:renewal']">池续约</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" align="center" fixed="right" v-if="!adminShow">
        <template slot-scope="scope">
          <el-button size="mini"  type="primary" plain icon="el-icon-view" @click="details(scope.row)" v-hasPermi="['pondManage:view']">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
    <el-dialog title="池成员回收" :visible.sync="showRecovery" width="30%" :before-close="handleClose">
      <el-form label-position="left"  class="pond-table-expand">
        <el-form-item label="代理商">
          <span>{{ recoveryForm.companyName }}</span>
        </el-form-item>
        <el-form-item label="流量池名称">
          <span>{{ recoveryForm.poolName }}</span>
        </el-form-item>
        <el-form-item label="类型">
          <span>{{ recoveryForm.poolType }}</span>
        </el-form-item>
        <el-form-item label="池卡总数">
          <span>{{ recoveryForm.cardNumber }}</span>
        </el-form-item>
        <el-form-item label="已用流量">
          <span>{{ recoveryForm.poolUseFlow }}</span>
        </el-form-item>
      </el-form>
      <el-alert style="margin-left: 24px;width: 90%;" title="回收当前池子中的所有卡，请谨慎操作！" type="warning" show-icon :closable="false"></el-alert>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitRecovery">确定回收</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { poolList } from "@/api/api.js";
import { agentDataList , poolCardRecovery} from "@/api/api.js";
export default {
  name:'pondList',
  data() {
    return{
      queryParams:{
        status:undefined
      },
      tableData:[],
      page: 1,
      pageSize: 20,
      total:0,
      sortOrder:"",
      sortName:"",
      dateRange:[],
      agentList:[],
      operator:[
        { value:"1",label:"单卡模式" },
        { value:"2",label:"总量模式" },
        { value:"3",label:"套餐模式" },
        { value:"5",label:"后付款模式" },
      ],
      sim:[
        {
          value: "选项1",
          label: "卡分配",
          icon: "el-icon-star-on"
        },
        {
          value: "选项2",
          label: "卡回收",
          icon: "el-icon-star-off"
        },
      ],
      showRecovery:false,
      recoveryForm:{}
    }
  },
  computed: {
    adminShow () {
      return this.$store.getters.user.userType =='1'
    },
  },
  watch: {
    $route: {
      handler: function(to, from){
        if(to.name == 'pondList'){
          this.initData();
        }
      },
      // 深度观察监听
      deep: true
    }
  },
  methods: {
    poolTotalFlowFormat(row){
      return row.poolTotalFlow === 'nullM' ?"-":row.poolTotalFlow;
    },
    handleAgent(item){
      let name = '['+item.username+']' + item.company 
      let commissionModel = item.commissionModel
      if(commissionModel === '0'){
          return name+'(比例)'
      }
      if(commissionModel === '1'){
          return name+'(底价)'
      }
      if(commissionModel === '2'){
          return name+'(流量池)'
      }
      return name+'(无)';
    },
    expireTimeFormat(row){
      if(row.expireTime == null){
        return "-";
      } else {
        let dt = new Date(row.expireTime);
        let year = dt.getFullYear();
        let month = dt.getMonth() + 1;
        let date = dt.getDate();
        return `${year}-${month}-${date}`;
      }
    },
    handleCommand(command,item){
      switch (command) {
        case "handleCardAllocation":
          this.handleCardAllocation(item);
          break;
        case "handleCardRecycle":
          this.handleCardRecycle(item);
          break;
        case "handlePoolRenewal":
          this.handlePoolRenewal(item);
          break;
        default:
          break;
      }
    },
    //卡分配
    handleCardAllocation(item){
      // this.$router.push("/pondManage/transfer");
      let params = item || {};
      this.$router.push({name:"pondTransfer",params: { poolId: params.poolId , userId:params.userId }});
    },
    //卡回收
    handleCardRecycle(item){
      if(!!item){
        this.showRecovery = true
        this.recoveryForm = item
      }else{
        this.$router.push("/pondManage/recovery");
      }

    },
    handleClose(){
      this.showRecovery = false
      this.recoveryForm = {}
    },
    //续约
    handlePoolRenewal(item){
      // this.$router.push("/pondManage/renewal");
      this.$store.dispatch('ClearPoolIccids')
      //type 为1 时  就是任何参数都设置为空
      let params = item || {type:1};
      this.$router.push({name:"pondRenewal",params: { poolId: params.poolId , userId:params.userId ,type:params.type }});
    },
    // 获取列表的数据
    initData(){
      let params= {
        model:{
          ... this.addDateRange(this.queryParams, this.dateRange),
          order: this.sortOrder,
          sort: this.sortName,
        },
        page: this.page,
        pageSize: this.pageSize,
      }
      poolList(params).then(res=>{
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      })
    },
    // 排序
    tableSortChange(val){
      if(val.order === null){
        this.sortOrder = "";
        this.sortName = "";
      } else {
        this.sortOrder = val.order === "descending" ? "desc" : "asc";
        if(val.prop == "createTime"){
          this.sortName = "create_time"
        }else if(val.prop == "expireTime"){
          this.sortName = "expire_time"
        }
      }

      this.initData();
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.initData();
    },
    add(){
      this.$router.push({ path: `/pondManage/add` });
    },
    // 详情
    details(row){
      this.$router.push({name:"pondDetails",params: { poolId: row.poolId , userId:row.userId}});
      // this.$router.push({path:"/pondManage/detail",query:{userId: row.userId,poolId: row.poolId}});
    },
    // 编辑
    editRow(row){
      this.$router.push({path:"/pondManage/edit",query:{poolId: row.poolId}});
    },
    // 复制
    copyRow(row){
      this.$router.push({path:"/pondManage/copy",query:{poolId: row.poolId}});
    },
    // 获取流量池用户
    selectPoolAgent(){
      agentDataList({level:"1"}).then(res => {
        this.agentList = res.data.data
      })
    },
    //确定回收
    submitRecovery(){
      poolCardRecovery({poolId:this.recoveryForm.poolId}).then(res=>{
        this.$modal.msgSuccess("池卡回收成功！")
        this.initData()
        this.handleClose()
      })
    }
    
  },
  mounted() {
    this.initData();
    if(this.adminShow){
      this.selectPoolAgent()
    }
  },
};
</script>
<style scoped lang="less">
  .pond-table-expand {
    font-size: 0;
    padding: 0px 25px
  }
  .pond-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .pond-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  /deep/ .el-table__fixed, /deep/ .el-table__fixed-right{
      height: 100% !important;
  }
</style>


